module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-180x180-eb033c42a4f3236d3b1c5a8aa68739c3.png";